
import { Component, Vue } from 'vue-property-decorator';

import LoginForm from '@/components/Forms/LoginForm.vue';
import TryForFreeForm from '@/components/Forms/FreeConsultForm.vue';
import { JwtStore } from '@/store/modules';
import Hex from '@/views/pages/hex.vue';
import Metrics from '@/views/pages/metrics.vue';
@Component({
  components: {
    LoginForm,
    TryForFreeForm,
    Hex,
    Metrics
  }
})
export default class LandingPage extends Vue {
  $refs!: {
    page: InstanceType<typeof HTMLElement>;
  };
  demoBarVisible = true;
  dialogVisible = false;
  loginVisible = false;
  freeConsultRequestVisible = false;
  overviewVideoVisible = false;
  sideBarVisible = false;
  slide = 0;
  top = true;
  fruitMapsFeatureColumn = [
    {
      name: 'feature',
      field: 'feature',
      label: 'Feature',
      sortable: true,
      align: 'left'
    }
  ];
  fruitMapsFeature = [
    {
      feature: 'Colour map your fruit distribution'
    },
    {
      feature:
        'Display volume of fruit per block to prioritise your picking areas'
    },
    { feature: 'Better plan labour hire, machinery to deploy & bins required' },
    { feature: 'Harvest date forecasting' },
    { feature: 'Fruit size prediction in development' },
    { feature: 'Negotiation tool for your customers' },
    { feature: 'Price stability due to accuracy' }
  ];

  urls = {
    contactUs: '/static/documents/Contact/FruitMaps contact pagepdf.pdf',
    webUsePolicy:
      '/static/documents/Policies/FruitMaps_General Web Policies .pdf',
    sassPolicy: '/static/documents/Policies/FruitMaps_SAAS Usage Policy .pdf',
    termsAndCondition:
      '/static/documents/Policies/FruitMaps_Terms and Conditions .pdf',
    pricing:
      '/static/documents/Pricing Guide/FruitMaps Orion Ag-Tech Pricing 2024.pdf'
  };

  slideCaptionTitle = 'Robust enough for researchers, easy enough for anyone.';
  slideCaptionDescription =
    'Developed with the CQUniversity Institute for Future Farming Systems, in consultation with key industry stakeholders and growers. FruitMaps is the perfect blend of advanced research paired with on farm know-how. ';

  slides = [
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Horticulturae 10.webp'),
      researchPaperLink: 'https://www.mdpi.com/2311-7524/10/1/108'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Horticulturae 10a.webp'),
      researchPaperLink: 'https://doi.org/10.3390/horticulturae10030301'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Software Architecture OFMIS.webp'),
      researchPaperLink: 'https://doi.org/10.17660/ActaHortic.2023.1360.43'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Agronomy 13.webp'),
      researchPaperLink: 'https://doi.org/10.3390/agronomy13102563'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Horticulturae 09.webp'),
      researchPaperLink: 'https://www.mdpi.com/2311-7524/9/4/489'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Sensors 23.webp'),
      researchPaperLink: 'https://www.mdpi.com/1424-8220/23/8/3868'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Horticulturae 08.webp'),
      researchPaperLink: 'https://www.mdpi.com/2311-7524/8/12/1223'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Detection and counting.webp'),
      researchPaperLink: 'https://doi.org/10.1016/j.biosx.2023.100407'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/Sustainability 15.webp'),
      researchPaperLink: 'https://www.mdpi.com/2071-1050/15/8/6769'
    },
    {
      slide: require('@/assets/L2/ResearchArticlesSnaps/JImaging 09.webp'),
      researchPaperLink: 'https://www.mdpi.com/2313-433X/9/2/53'
    }
  ];

  get startFreeTrialButtonClass() {
    let classes = '';
    if (this.$q.screen.width >= 1080) {
      classes = 'text-h3';
    } else if (this.$q.screen.width >= 900) {
      classes = 'text-h4';
    } else if (this.$q.screen.width >= 700) {
      classes = 'text-h5';
    } else if (this.$q.screen.width >= 560) {
      classes = 'text-h6';
    } else if (this.$q.screen.width >= 450) {
      classes = 'text-body2';
    }
    return classes;
  }

  get buttonSize() {
    let size = 'md';
    if (this.$q.screen.gt.md) {
      size = 'xl';
    } else if (this.$q.screen.gt.xs) {
      size = 'lg';
    }
    return size;
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  scrollHandler() {
    if (window.scrollY <= 0) {
      this.top = true;
    } else {
      this.top = false;
    }
  }

  beforeMount() {
	// I am not empty
  }

  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  }

  login() {
    if (JwtStore.isLoggedIn) {
      this.$router.push({ name: 'Home' });
    } else {
      this.loginVisible = true;
    }
  }
}
